import { createSelector } from "@reduxjs/toolkit";

import type { SectionState } from "./sections.types";

const sectionsStateSlice = (state: { sections: SectionState }) =>
	state.sections;

export const selectedSectionSelector = createSelector(
	sectionsStateSlice,
	(state) => state.selectedSection,
);

export const activeFilterTypeSelector = createSelector(
	sectionsStateSlice,
	(state) => state.activeFilterType,
);

export const sectionModalsSelector = createSelector(
	sectionsStateSlice,
	(state) => state.modals,
);

export const draftFiltersSelector = createSelector(
	sectionsStateSlice,
	(state) => state.draftFilters,
);

export const automaticallyRemovingPublicPermissionSelector = createSelector(
	sectionsStateSlice,
	(state) => state.automaticallyRemovingPublicPermission,
);

export const pageNumberSelector = createSelector(
	sectionsStateSlice,
	(state) => state.pagination.pageNumber,
);
